<template>
  <LcDigitInputGroup
    ref="inputGroup"
    v-bind="{ ...digitInputGroupProps, value }"
    v-slot="{ setRef }"
    class="number-picker"
    feedback-message-class="text-center"
    wrapper-class="justify-center gap-100"
  >
    <LcDigitInput
      v-for="({ name }, index) in fields"
      v-bind="{ index }"
      :key="name"
      :ref="setRef"
      aria-labelledby="number-picker-label"
      :disabled="isDisabled(name)"
      @click="inputGroupRef?.focusInputByIndex(index)"
      @update:value="(value) => $emit('change', { name, value })"
    />
  </LcDigitInputGroup>
</template>

<script lang="ts" setup>
import type { LcDigitInputGroupProps } from '@lottocom/frontend-components'

export type NumberPickerChangeEventValue = {
  name: string
  value: Maybe<number>
}

export type NumberPickerProps = Omit<LcDigitInputGroupProps, 'value'> & {
  disabledFields?: string[]
  fields?: { name: string }[]
  value?: Maybe<number>[]
}

type NumberPickerEmits = {
  (event: 'change', value: NumberPickerChangeEventValue): void
}

defineEmits<NumberPickerEmits>()
const {
  disabledFields = [],
  fields = [],
  value = [],
  ...digitInputGroupProps
} = defineProps<NumberPickerProps>()

const inputGroupRef = useTemplateRef('inputGroup')

const isDisabled = (field: string) => disabledFields.includes(field)

defineExpose({
  focusFirstEnabledInput: () => inputGroupRef.value?.focusFirstEnabledInput(),
})
</script>

<style lang="scss" scoped>
.number-picker {
  :deep(.lc-feedback-message) {
    height: token('size/space/gap/400');
    margin-bottom: token('size/space/gap/025');
  }
}
</style>
